<template>
    <div class="user-center">
        <div class="left-wrapper">
            <div class="left-top-wrapper" v-loading="honorLoading">
                <div class="title-content">
                    <p class="title-left">
                        <img src="../../images/personal_center/honor.png" height="18px" width="18px" alt="">
                        <span>个人荣誉</span>
                    </p>
                    <p class="title-right" @click="goHonorRuler">更多荣誉说明 ></p>
                </div>
                <ul v-if="honorList.length" class="honor-list">
                    <el-popover
                        placement="top"
                        trigger="hover"
                        v-for="(honor, index) in honorList"
                        :key="index"
                        popper-class="honor-popover">
                        <p class="belong">
                            <span class="light">{{ honor.medal.name }}</span>
                            <span>{{ `（${honor.medal.total_get_count}人获得）` }}</span>
                        </p>
                        <p class="desc">{{ honor.medal.desc }}</p>
                        <div slot="reference" class="honor-item">
                            <p class="honor-name">{{ honor.name }}</p>
                            <img class="medal-icon" :src="honor.medal.icon_on" alt="">
                        </div>
                    </el-popover>
                </ul>
                <div v-else class="data-null">
                    <img src="../../images/personal_center/data-null.png" alt="">
                    <p>暂未获取任何荣誉</p>
                </div>
            </div>
            <div class="left-bottom-wrapper" v-loading="profileLoading">
                <div class="title-content">
                    <p class="title-left">
                        <img src="../../images/personal_center/honor.png" height="18px" width="18px" alt="">
                        <span>个人简介</span>
                    </p>
                </div>
                <ul class="info-list">
                    <li
                        class="info-item"
                        v-for="(info, index) in userProfileInfo"
                        :key="index">
                        <span class="label">{{ info.label }}</span>
                        <span v-if="!Boolean(info.status)" class="unpublished">未公开</span>
                        <span v-else-if="!info.value" class="content">--</span>
                        <span v-else-if="info.type === 'industry'" class="content">{{ info.value | formatIndustry }}</span>
                        <span v-else-if="info.type === 'position'" class="content">{{ info.value | formatPosition }}</span>
                        <span v-else :title="info.value" class="content">{{ info.value }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="right-wrapper">
            <div class="influence-wrapper">
                <p class="influence-title">影响力</p>
                <div class="overview-content">
                    <p class="title">综合评价</p>
                    <el-rate
                        class="influence-rate"
                        v-model="statisticsInfo.product_score"
                        :disabled="true"
                        void-icon-class="el-icon-star-on"
                        disabled-void-color="#c4c6cc"
                        :colors="['#fe9c00', '#fe9c00', '#fe9c00']">
                    </el-rate>
                    <p class="desc">
                        <span class="count">{{ statisticsInfo.saas_num || 0 }}</span>
                        <span>个作品，平均</span>
                        <span class="count">{{ statisticsInfo.product_score || 0 }}</span>
                        <span>颗星</span>
                    </p>
                    <ul class="user-list">
                        <li
                            v-for="(val, index) in userBasicList"
                            :key="index">
                            <p class="item-label">{{ val.label }}</p>
                            <div
                                :class="['item-count', {'link': val.url}]"
                                @click="goUserBasicTab(val)">
                                {{ statisticsInfo[val.type] || 0 }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="dynamic-wrapper">
                <p class="dynamic-title">他的动态</p>
                <div class="dynamic-list" v-loading="dynamicLoading">
                    <template v-if="dynamicList.length">
                        <ul>
                            <li :class="['dynamic-item', { 'last-date': dynamicList.length === index + 1 && !isShowLoadMore }]" v-for="(followItem, index) in dynamicList" :key="index">
                                <dl class="dynamic-content">
                                    <dt>
                                        <div class="date-icon">
                                            <img width="20px" height="20px" src="../../images/personal_center/date.png" alt="">
                                        </div>
                                        <span>{{ followItem.label }}</span>
                                    </dt>
                                    <dd v-for="(item, cIndex) in followItem.items" :key="cIndex" :class="{ 'last-content': cIndex === 0 && followItem.items.length === 1 }">
                                        <span class="time">{{ item.created_time }}</span>
                                        <p class="content" v-html="filterXSS(item.template)"></p>
                                    </dd>
                                </dl>
                            </li>
                        </ul>
                        <div class="load-more" v-if="isShowLoadMore && !dynamicLoading">
                            <a href="javascript:;" class="text-blue" @click="loadMore">查看更多动态</a>
                        </div>
                    </template>
                    <template v-else-if="!dynamicLoading">
                        <div class="work-null">
                            <img src="../../images/personal_center/data-null.png" alt="" />
                            <p>暂无动态,<router-link to="/s-mart/community">去逛逛？</router-link></p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const profileList = [
        {
            label: 'QQ号码：',
            type: 'qq'
        }, {
            label: '邮箱地址：',
            type: 'email'
        }, {
            label: '手机号码：',
            type: 'phone'
        }, {
            label: '个人主页：',
            type: 'homepage'
        }, {
            label: '公司名称：',
            type: 'company'
        }, {
            label: '公司电话：',
            type: 'company_phone'
        }, {
            label: '所属行业：',
            type: 'industry'
        }, {
            label: '所在职位：',
            type: 'position'
        }
    
    ]
    const userBasicList = [
        {
            label: '提问',
            type: 'qa_num',
            url: '/question'
        }, {
            label: '回答',
            type: 'comment_num',
            url: '/question',
            params: 'my_answer'
        }, {
            label: '文章',
            type: 'article_num',
            url: '/article'
        }, {
            label: '作品',
            type: 'saas_num',
            url: '/product'
        }, {
            label: '获赞',
            type: 'vote_up_num'
        }, {
            label: '粉丝',
            type: 'fan_num'
        }
    ]
    import tools from '@/js/tools.js'
    export default {
        name: 'userCenter',
        props: {
            userId: {
                type: [String, Number]
            },
            statisticsInfo: {
                type: Object,
                default: () => ({})
            }
        },
        filters: {
            formatIndustry (data) {
                data = data.replace(/^internet$/, "互联网")
                data = data.replace(/^isp$/, "运营商")
                data = data.replace(/^bank$/, "银行")
                data = data.replace(/^power$/, "电力能源")
                data = data.replace(/^LOG$/, "物流交通")
                data = data.replace(/^SAC$/, "基金证券")
                data = data.replace(/^gov$/, "政法机关")
                data = data.replace(/^company$/, "企业服务")
                data = data.replace(/^si$/, "系统集成商")
                data = data.replace(/^student$/, "在校学生")
                data = data.replace(/^other$/, "其他")
                return data
            },
            formatPosition (data) {
                data = data.replace(/^op$/, "运维工程师")
                data = data.replace(/^cio$/, "CIO 首席信息官")
                data = data.replace(/^cto$/, "CTO 首席技术官")
                data = data.replace(/^ceo$/, "CEO 首席执行官")
                data = data.replace(/^test$/, "研发/测试工程师")
                data = data.replace(/^support$/, "技术支持/售前/售后")
                data = data.replace(/^RCE$/, "IT 咨询顾问")
                data = data.replace(/^student$/, "学生")
                data = data.replace(/^other$/, "其他")
                return data
            }
        },
        data () {
            return {
                honorLoading: false,
                honorList: [],
                profileLoading: false,
                userProfileInfo: [],
                userBasicList: userBasicList,
                dynamicLoading: false,
                page: 1,
                dynamicList: [],
                isShowLoadMore: false
            }
        },
        watch: {
            userId: {
                handler (val) {
                    if (val) {
                        this.getUserConfig()
                        this.getUserHonor()
                        this.getFeed()
                    }
                },
                immediate: true
            }
        },
        methods: {
            goHonorRuler () {
                const routeData = this.$router.resolve({
                    path: '/s-mart/honor'
                })
                window.open(routeData.href, '_blank')
            },
            async getUserHonor () {
                try {
                    this.honorLoading = true
                    const path = `profile/honor/?user=${this.userId}`
                    await axios.get(myUrl + path).then(res => {
                        const resp = res.data.data
                        this.honorList = resp.results
                        this.honorList.forEach(item => {
                            if (item.medal.name.split('-')[1]) {
                                item.name = item.medal.name.split('-')[0]
                            }
                        })
                    })
                } catch (error) {
                    console.warn(error)
                } finally {
                    this.honorLoading = false
                }
            },
            async getUserConfig () {
                try {
                    this.profileLoading = true
                    await axios.post(myUrl + `profile/user/detail/${this.userId}/`).then(res => {
                        const resp = res.data
                        const { user_profile: userProfile, user_basic: userBasic } = resp.data
                        this.userProfileInfo = profileList.map(item => {
                            const info = userProfile[item.type]
                            if (info) {
                                return Object.assign({}, item, {
                                    status: info.status,
                                    value: info.value
                                })
                            }
                            return item
                        })
                        this.$parent.sexual = userBasic.sexual
                        this.$parent.setUserBadges(userBasic.user_badges)
                    })
                } catch (error) {
                    console.warn(error)
                } finally {
                    this.profileLoading = false
                }
            },
            goUserBasicTab (info) {
                const { url, params } = info
                if (!url) return
                const path = `/s-mart/personal_center${url}/${this.userId}`
                this.$router.push({
                    path,
                    query: {
                        tabName: params || undefined
                    }
                })
            },
            /*
            ** 获取动态
            */
            async getFeed (more) {
                try {
                    let url = `profile/user/${this.userId}/dynamic/`

                    //获取更多动态
                    if (more) {
                        url = url + `?page=${this.page}`
                    } else  {
                        this.dynamicLoading = true
                    }
                    await axios.get(myUrl + url).then(response => {
                        let res = response.data
                        if (res.code !== '00' || !res.result) return

                        const { results, next } = res.data
                        const dynamicList = this.dynamicList
                        results.forEach(item => {
                            const length = dynamicList.length
                            const lastDynamic = dynamicList[length - 1]
                            if (lastDynamic && lastDynamic.created_date === item.created_date) {
                                lastDynamic.items.push(item)
                            } else {
                                let createDate = item.created_date.replace(/[\u4e00-\u9fa5]/g, '-')
                                createDate = createDate.slice(0, -1)
                                dynamicList.push({
                                    label: tools.handleTime(createDate),
                                    created_date: item.created_date,
                                    items: [item]
                                })
                            }
                        })
                        // 是否可以加载更多
                        this.isShowLoadMore = next
                        this.page = next && next.split('page=')[1] || 0
                    })
                } catch (error) {
                    console.warn(error)
                } finally {
                    this.dynamicLoading = false
                }
            },
            loadMore () {
                this.getFeed(true)
            }
        }
    }
</script>

<style lang="scss">
    .influence-rate .el-rate__item .el-rate__icon {
        font-size: 18px;
    }
    .honor-popover {
        font-size: 12px;
        .belong {
            color: #c4c6cc;
            margin-bottom: 3px;
            .light {
                color: #313238;
                font-weight: 700;
                font-family: PingFangSC, PingFangSC-Medium;
            }
            .desc {
                color: #63656e;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .user-center {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        font-family: Microsoft YaHei;
        .left-wrapper {
            width: 320px;
            font-size: 12px;
            .left-top-wrapper, .left-bottom-wrapper {
                background: #ffffff;
                border-radius: 2px;
                box-shadow: 0px 2px 4px 0px rgba(25,25,41,0.05);
            }
            .title-content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 17px;
                .title-left {
                    display: flex;
                    font-size: 14px;
                    font-weight: 700;
                    color: #313238;
                    line-height: 19px;
                    img {
                        margin-right: 8px;
                    }
                }
                .title-right:hover {
                    cursor: pointer;
                    color: #3a84ff;
                }
            }
            .left-top-wrapper {
                min-height: 352px;
                padding: 24px 24px 38px;
                margin-bottom: 16px;
                .data-null {
                    text-align: center;
                    margin-top: 83px;
                    img {
                        display: inline-block;
                        width: 120px;
                        height: 100px;
                        margin-bottom: 16px;
                    }
                }
                .honor-list {
                    display: flex;
                    flex-wrap: wrap;
                    padding-top: 10px;
                    min-height: 210px;
                    > span {
                        margin: 0 10px 16px 0;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                    }
                    .honor-item {
                        width: 84px;
                        height: 84px;
                        opacity: 1;
                        background: #f5f7fa;
                        border-radius: 4px;
                        position: relative;
                        .honor-name {
                            position: absolute;
                            font-family: TencentSansW3;
                            top: 20px;
                            font-size: 10px;
                            display: inline-block;
                            width: 100%;
                            text-align: center;
                            color: #fff;
                        }
                        .medal-icon {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
            .left-bottom-wrapper {
                padding: 24px 24px 50px;
                .info-list {
                    min-height: 256px;
                }
                .info-item {
                    display: flex;
                    align-items: center;
                    line-height: 32px;
                    font-size: 13px;
                    .label {
                        flex-shrink: 0;
                        width: 65px;
                        padding: 0;
                        color: #63656e;
                        margin-right: 8px;
                        font-weight: normal;
                    }
                    .content {
                        color: #313238;
                        overflow: hidden;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                    }
                    .unpublished {
                        color: #979ba5;
                    }
                }
            }
        }
        .right-wrapper {
            width: 862px;
            padding: 24px 24px 0;
            background: #fff !important;
            border-radius: 2px;
            box-shadow: 0px 2px 4px 0px rgba(25,25,41,0.05);
            .influence-wrapper {
                padding-bottom: 46px;
                .influence-title {
                    font-size: 14px;
                    color: #313238;
                    font-weight: 700;
                    margin-bottom: 16px;
                }
                .overview-content {
                    color: #63656e;
                    text-align: center;
                    .title {
                        font-size: 22px;
                        color: #313238;
                        margin-bottom: 16px;
                    }
                    .influence-rate {
                        margin-bottom: 16px;
                        .el-rate__item .el-rate__icon {
                            font-size: 20px;
                        }
                    }
                    .desc {
                        margin-bottom: 30px;
                        .count {
                            color: #63656e;
                            font-weight: 600;
                        }
                    }
                    .user-list {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 16px;
                        li {
                            margin-right: 47px;
                            .item-label {
                                margin-bottom: 19px;
                            }
                            .item-count {
                                width: 66px;
                                height: 40px;
                                text-align: center;
                                line-height: 40px;
                                color: #313238;
                                font-size: 20px;
                                font-weight: 700;
                                background: #f5f7fa;
                                border-radius: 2px;
                                font-family: Arial, Arial-Regular;
                                &:hover {
                                    background: #e1ecff;
                                    color: #3a84ff;
                                }
                                &.link {
                                    cursor: pointer;
                                }
                            }
                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    }
                }
            }
            .dynamic-wrapper {
                padding-bottom: 20px;
            }
            .dynamic-title {
                font-size: 14px;
                color: #313238;
                font-weight: 700;
                margin-bottom: 24px;
            }
            .dynamic-list {
                min-height: 570px;
                .dynamic-item {
                    color: #313238;
                    .dynamic-content {
                        dt {
                            display: flex;
                            align-items: center;
                            font-family: PingFangSC, PingFangSC-Semibold;
                        }
                        .date-icon {
                            width: 32px;
                            height: 32px;
                            text-align: center;
                            line-height: 32px;
                            margin-right: 12px;
                            background: #e1ecff;
                            border-radius: 2px;
                        }
                        dd {
                            position: relative;
                            display: flex;
                            align-items: flex-start;
                            margin-left: 15px;
                            padding: 0px 0 28px 12px;
                            border-left: 2px solid #dcdee5;
                            .time {
                                font-family: PingFangSC, PingFangSC-Semibold;
                            }
                            .content {
                                color: #63656e;
                                line-height: 19px;
                                margin-left: 8px;
                            }
                            &::before {
                                content: '';
                                position: absolute;
                                left: -9px;
                                top: 2px;
                                height: 16px;
                                width: 16px;
                                border-radius: 50%;
                                border: 4px solid #fff;
                                background: #dcdee5;
                            }
                            &:nth-of-type(1) {
                                padding-top: 28px;
                                &::before {
                                    top: 30px;
                                }
                            }
                        }
                    }
                    &.last-date {
                        dd:nth-last-child(2) {
                            padding-bottom: 22px;
                        }
                        dd:last-child {
                            &::before {
                                top: 4px;
                            }
                            padding-bottom: 0;
                        }
                        .last-content {
                            padding: 22px 0 0 12px !important;
                            &::before {
                                top: 30px !important;
                            }
                        }
                    }
                }
            }
            .work-null {
                text-align: center;
                padding: 136px 0;
                img {
                    display: inline-block;
                    width: 120px;
                    height: 100px;
                }
                p {
                    margin-top: 25px;
                    color:#878996;
                    a{
                        color: #3a84ff;
                    }
                }
            }
            .text-blue {
                color: #3a84ff;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// user_center.vue?03d73763